import { render, staticRenderFns } from "./EducationCloud.vue?vue&type=template&id=0ad2f001"
import script from "./EducationCloud.vue?vue&type=script&lang=js"
export * from "./EducationCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports